import { createContext, useContext, useState } from "react";

const EnquiryContext = createContext(null);
export const useEnquiry = () => useContext(EnquiryContext);

export function EnquiryProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [prefill, setPrefill] = useState({});

  const openEnquiry = (data = {}) => {
    setPrefill(data);
    setOpen(true);
  };
  const closeEnquiry = () => setOpen(false);

  return (
    <EnquiryContext.Provider value={{ open, prefill, openEnquiry, closeEnquiry }}>
      {children}
    </EnquiryContext.Provider>
  );
}
